module.exports = __webpack_public_path__ + "img/bg.b2fae5dc.png";